var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qrcode',{attrs:{"value":_vm.qrcodeUrl,"options":{ size: 202 }}})
}
var staticRenderFns = []

export { render, staticRenderFns }